import { GoogleMap, Marker } from '@react-google-maps/api'
import React, { useState } from 'react'

export default function MapMarker ({ location }) {
  const [mapInstance, setMapInstance] = useState(false)
  const coordinates = location.coordinates
  const lat = coordinates[1]
  const lng = coordinates[0]
  return (
    <>
      {lat && lng
        ? (
          <GoogleMap
            id='marker-example'
            mapContainerStyle={{
              height: '400px'
            }}
            zoom={20}
            onLoad={(map) => setTimeout(() => setMapInstance(map))}
            center={{ lat, lng }}
            options={{ mapTypeControl: true, streetViewControl: false, clickableIcons: false, fullscreenControl: false }}
          >
            {mapInstance && location && <Marker
              position={{ lat, lng }}
                                        />}
          </GoogleMap>
          )
        : null}
    </>
  )
}
